import { Icon } from '@iconify/react';
import { FC } from 'react';
import { UIButton } from 'src/components/UI/UIButton.tsx';
import { Agent } from 'src/types/agents.ts';
import { useUnwrapToken } from '../hooks/useUnwrapToken';

interface UniSwapProps {
  agent: Agent;
}

export const UniSwapTrade: FC<UniSwapProps> = ({ agent }) => {
  const { unwrap, isPendingUnwrap, isNeedToUnwrap } = useUnwrapToken(
    agent.token_info.updated_token_address,
  );

  return (
    <div className="flex flex-col gap-4 rounded-3xl bg-[#1A1C1E] p-6">
      <h2 className="mb-2 text-lg font-semibold">Swap</h2>

      {isNeedToUnwrap && (
        <UIButton
          buttonColor="unwrap"
          onClick={() => unwrap()}
          processing={isPendingUnwrap}
          className="w-full"
          startIcon={<Icon icon="fa6-solid:wand-magic-sparkles" />}
        >
          Unwrap Graduated Tokens
        </UIButton>
      )}

      <a
        className="w-full"
        href={`https://app.uniswap.org/swap?outputCurrency=${agent.token_info.updated_token_address}`}
      >
        <UIButton buttonColor="uniswap" className="w-full">
          Trade on Uniswap
        </UIButton>
      </a>
    </div>
  );
};
